// N40 — is this a phone? The hotel's link opens the invitation in the app on a
// phone and on the desk at a desk, with the same token and the same words. Links
// sent before N40 point at the desk's join page, which hands a phone to the app.
// The app has the same rule (app/src/shell/reach.ts onAPhone); no shared package
// exists between the two, so it is kept in step by hand.
//
// A phone is an iPhone, an Android phone (Android's tablets leave "Mobile" out of
// their agent), or an app's own browser on an Android phone. An iPad, a tablet
// and a computer are desks: the desk's pages are made for their screens.
export function onAPhone(ua: string): boolean {
  if (/iPhone|iPod|Windows Phone/i.test(ua)) return true;
  if (/Android/i.test(ua) && /Mobile/i.test(ua)) return true;
  return /Android/i.test(ua) && /; wv\)|\bViber\b|FB_IAB\/|FBAN\/|\bInstagram\b/i.test(ua);
}

/**
 * Where the app opens this link: the same token, on the app's own join route —
 * marked as handed over (`via=desk`), so the app never hands it back (the loop
 * guard, N40 review: two hand-kept copies of the phone check must never bounce a
 * visitor between the two pages).
 */
export function appJoinUrl(token: string): string {
  return `/app/#/join?t=${encodeURIComponent(token)}&via=desk`;
}

/** Whether this page was handed over from the app — then it never hands back. */
export function handedOverFromApp(hash = window.location.hash): boolean {
  return new URLSearchParams(hash.split('?')[1] ?? '').get('via') === 'app';
}
